module.exports = __webpack_public_path__ + "img/keep1.9bd8ee44.svg";